/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react';
import { string, bool, func } from 'prop-types';
import classNames from 'clsx';

import Checkmark from 'gfx/vector/checkmark.svg';

import styles from './checkbox.scss';

/**
 * This is the Checkbox component class.
 *
 * @author Magnus Bergman <magnus@apt.no>
 */
const Checkbox = ({
  name,
  value,
  required,
  readOnly,
  disabled,
  error,
  light,
  onFocus,
  onBlur,
  onChange,
}) => (
  <div
    className={classNames(styles.control, {
      [styles.error]: error,
      [styles.light]: light,
      [styles.readOnly]: readOnly || disabled,
    })}
  >
    <input
      id={name}
      type="checkbox"
      {...{
        name,
        required,
        readOnly,
        disabled,
        onFocus,
        onBlur,
        onChange,
      }}
      checked={value}
    />
    <span className={styles.controlIndicator}>
      {value && (
        <span className={styles.checkmark}>
          <Checkmark />
        </span>
      )}
    </span>
  </div>
);

/**
 * Declare expected property types.
 *
 * @type {Object}
 */
Checkbox.propTypes = {
  name: string.isRequired,
  value: bool,
  required: bool,
  readOnly: bool,
  disabled: bool,
  error: bool,
  light: bool,
  onFocus: func,
  onBlur: func,
  onChange: func,
};

/**
 * Set default properties.
 *
 * @type {Object}
 */
Checkbox.defaultProps = {
  value: false,
  required: false,
  readOnly: false,
  disabled: false,
  error: false,
  light: false,
  onFocus: () => {},
  onBlur: () => {},
  onChange: () => {},
};

export default Checkbox;
